import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

import { FAVORITES } from 'components/Dashboards/Reporting/reporting.consts';

export const optionsToTags = (options: readonly { label: string; value: number }[]): Tag[] => {
    return options.map((option) => ({
        id: option.value,
        name: option.label,
    }));
};
export const tagsToOptions = (tags: Tag[]) => {
    const options =
        tags?.map((tag) => ({
            label: tag.name,
            value: tag.id,
        })) ?? [];
    return options;
};

export const isNewTagNamedFavorites = (option: ISelectOption<number> & { __isNew__?: boolean }) =>
    Boolean(option.__isNew__ && option.label.trim().toLowerCase() === FAVORITES.toLowerCase());
